import {Component, Input} from '@angular/core';
import {ProductInFinishProduct} from '../../interface/product-in-finish-product';

@Component({
  selector: 'fb-gsm-and-weight',
  templateUrl: './gsm-and-weight.component.html',
  styleUrls: ['./gsm-and-weight.component.scss']
})
export class GsmAndWeightComponent {
	@Input() dataGsm: ProductInFinishProduct = {} as ProductInFinishProduct;


}
